import DepositsNameSearchTable from "../components/SOD/BranchOfficeDeposits/DepositsNameSearchTable";
import { connect } from "react-redux";
import { All, KeyValue, SortDirection } from "../interfaces";
import * as actions from "../common/actions";
import { Dispatch } from "react";

function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(actions.updateSortOrder(sortField, sortDirection));
    },
    updateSearch: (field: string, value: string) => {
      dispatch(actions.updateSearch(field, value));
    },
    updateUi: (field: string, value: string) => {
      dispatch(actions.updateUi(field, value));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DepositsNameSearchTable);
